var _ellipse, _path, _rect, _ellipse2, _path2, _path3, _rect2, _rect3, _path4, _path5, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAiError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.4898,
    cy: 24,
    rx: 24.4898,
    ry: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8462 14.1259C19.8462 12.593 21.0889 11.3503 22.6218 11.3503H25.5412C27.0741 11.3503 28.3168 12.593 28.3168 14.1259V14.1259H19.8462V14.1259Z",
    fill: "url(#paint0_linear_2140_892)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.9075,
    y: 8.21313,
    width: 0.580177,
    height: 3.37895,
    fill: "url(#paint1_linear_2140_892)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.1973,
    cy: 7.18715,
    rx: 1.21837,
    ry: 1.26711,
    fill: "url(#paint2_linear_2140_892)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6809 36.6401C11.9956 36.6315 9.84554 32.478 9.23079 30.4001C8.46156 30.4001 6.9231 30.0161 6.9231 28.4801V23.2001C7.07641 22.5623 7.93254 21.3843 10.131 21.7562C11.2909 17.7441 14.9698 13.1647 23.9992 13.575C33.0262 13.1662 36.704 17.7455 37.8635 21.7571C40.0661 21.3823 40.9235 22.5618 41.0769 23.2001V28.4801C41.0769 30.0161 39.5385 30.4001 38.7692 30.4001C38.1539 32.4801 36 36.6401 32.3077 36.6401H15.6809Z",
    fill: "url(#paint3_linear_2140_892)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7692 36.6401H15.6923C12 36.6401 9.84617 32.4801 9.23079 30.4001C8.46156 30.4001 6.9231 30.0161 6.9231 28.4801V23.2001C7.07694 22.5601 7.93848 21.3761 10.1539 21.7601M15.2308 36.6401H32.3077C36 36.6401 38.1539 32.4801 38.7692 30.4001C39.5385 30.4001 41.0769 30.0161 41.0769 28.4801V23.2001C40.9231 22.5601 40.0616 21.3761 37.8462 21.7601M9.69262 25.1199C9.53877 20.9599 12.2769 12.8321 24.4616 13.6001M38.3017 25.1201C38.4555 20.9601 35.7174 12.8323 23.5328 13.6003",
    stroke: "url(#paint4_linear_2140_892)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3846,
    y: 19.3601,
    width: 21.2308,
    height: 11.52,
    rx: 5.76,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3846,
    y: 19.3601,
    width: 21.2308,
    height: 11.52,
    rx: 5.76,
    stroke: "url(#paint5_linear_2140_892)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.923 25.6C30.923 26.3953 30.3031 27.04 29.5384 27.04C28.7737 27.04 28.1538 26.3953 28.1538 25.6C28.1538 24.8047 28.7737 24.16 29.5384 24.16C30.3031 24.16 30.923 24.8047 30.923 25.6Z",
    fill: "url(#paint6_linear_2140_892)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8461 25.6C19.8461 26.3953 19.2262 27.04 18.4615 27.04C17.6968 27.04 17.0769 26.3953 17.0769 25.6C17.0769 24.8047 17.6968 24.16 18.4615 24.16C19.2262 24.16 19.8461 24.8047 19.8461 25.6Z",
    fill: "url(#paint7_linear_2140_892)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 34,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#EE4352",
    fillOpacity: 0.969
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 34C40.6155 34 39.2622 34.4105 38.111 35.1797C36.9599 35.9489 36.0627 37.0421 35.5328 38.3212C35.003 39.6003 34.8644 41.0078 35.1345 42.3656C35.4046 43.7235 36.0713 44.9708 37.0503 45.9497C38.0292 46.9287 39.2765 47.5954 40.6344 47.8655C41.9922 48.1356 43.3997 47.997 44.6788 47.4672C45.9579 46.9373 47.0511 46.0401 47.8203 44.889C48.5895 43.7378 49 42.3845 49 41C48.998 39.1441 48.2599 37.3648 46.9475 36.0525C45.6352 34.7401 43.8559 34.002 42 34V34ZM42 46.8333C40.8463 46.8333 39.7185 46.4912 38.7592 45.8502C37.7999 45.2093 37.0522 44.2982 36.6107 43.2323C36.1692 42.1664 36.0537 40.9935 36.2788 39.862C36.5038 38.7304 37.0594 37.691 37.8752 36.8752C38.691 36.0594 39.7304 35.5038 40.862 35.2788C41.9935 35.0537 43.1664 35.1692 44.2323 35.6107C45.2982 36.0522 46.2093 36.7999 46.8502 37.7592C47.4912 38.7185 47.8333 39.8463 47.8333 41C47.8316 42.5466 47.2165 44.0293 46.1229 45.1229C45.0293 46.2165 43.5466 46.8316 42 46.8333V46.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 36.9167C41.8454 36.9167 41.697 36.9782 41.5876 37.0876C41.4782 37.197 41.4167 37.3454 41.4167 37.5001V42.1667C41.4167 42.3215 41.4782 42.4698 41.5876 42.5792C41.697 42.6886 41.8454 42.7501 42.0001 42.7501C42.1548 42.7501 42.3032 42.6886 42.4126 42.5792C42.522 42.4698 42.5834 42.3215 42.5834 42.1667V37.5001C42.5834 37.3454 42.522 37.197 42.4126 37.0876C42.3032 36.9782 42.1548 36.9167 42.0001 36.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5834 44.5001C42.5834 44.1779 42.3223 43.9167 42.0001 43.9167C41.6779 43.9167 41.4167 44.1779 41.4167 44.5001C41.4167 44.8223 41.6779 45.0834 42.0001 45.0834C42.3223 45.0834 42.5834 44.8223 42.5834 44.5001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2140_892",
    x1: 18.4616,
    y1: 12.9739,
    x2: 20.4722,
    y2: 16.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2140_892",
    x1: 23.8126,
    y1: 10.1896,
    x2: 24.3238,
    y2: 10.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2140_892",
    x1: 22.5806,
    y1: 7.40242,
    x2: 24.2826,
    y2: 8.29076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2140_892",
    x1: 1.34026,
    y1: 27.0562,
    x2: 19.7972,
    y2: 41.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2140_892",
    x1: 1.34026,
    y1: 27.0562,
    x2: 19.7972,
    y2: 41.8748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2140_892",
    x1: 9.91423,
    y1: 26.0987,
    x2: 19.3452,
    y2: 35.5332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2140_892",
    x1: 27.7011,
    y1: 25.8447,
    x2: 29.6354,
    y2: 26.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2140_892",
    x1: 16.6242,
    y1: 25.8447,
    x2: 18.5585,
    y2: 26.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90205D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(35 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAiError);
export default __webpack_public_path__ + "static/media/ChatAiError.43c608f7.svg";
export { ForwardRef as ReactComponent };